import { useCallback, useMemo } from 'react';

import { DEFAULT_FORM_FIELD } from '~entities/parent/constants/default-form-fields';
import { useGetParentFormConfig } from '~entities/parent/api/fetch-parent-form-config';
import { Section } from '~entities/parent/model/parent-form-config.type';
import type { FormConfigField } from '~shared/api/form-config';

const defaultStudentFieldMap = new Map(
  DEFAULT_FORM_FIELD.filter(
    (field) => (field.section as Section) === Section.Students,
  ).map((field) => [field.fieldId, field]),
);

export function useStudentFieldConfig() {
  const { data: parentFormConfig } = useGetParentFormConfig();

  const studentFieldConfigMap = useMemo(() => {
    const map = new Map<string, FormConfigField>(defaultStudentFieldMap);

    const apiFields =
      parentFormConfig?.formFields.filter(
        (field) => field.section === Section.Students,
      ) ?? [];

    for (const field of apiFields) {
      map.set(field.fieldId, field as FormConfigField);
    }

    return map;
  }, [parentFormConfig]);

  const getFieldConfig = useCallback(
    (fieldId: string) => studentFieldConfigMap.get(fieldId),
    [studentFieldConfigMap],
  );

  return { getFieldConfig };
}
